import { singularizeStepType } from "shared/lib/utils"
import VanillaFittty from "shared/scripts/vanilla_fittty"

const TqaListTabs = async () => {
  // Tab switching for TQA module
  document.querySelectorAll(".tab-content.filters a").forEach(tab => {
    tab.addEventListener("click", event => {
      event.preventDefault()
      const tab = event.target.closest("a")

      if (tab.classList.contains("active")) return

      document.querySelectorAll(".tab-content.filters a").forEach(tab => tab.classList.remove("active"))
      tab.classList.add("active")

      const tabContent = document.querySelector(`section[data-tab=${tab.dataset.target}]`)
      document.querySelectorAll("section[data-tab]").forEach(content => content.classList.add("hide"))
      tabContent?.classList.remove("hide")

      void VanillaFittty(tabContent as HTMLElement)

      window.history.replaceState({ url: tab.href }, "", tab.href)
    })
  })

  document.querySelectorAll(".tqas-tab-nav .tqa-tab").forEach(tab => {
    tab.addEventListener("click", event => {
      event.preventDefault()
      const clickedTab = event.currentTarget
      if (!(clickedTab instanceof HTMLElement)) return
      if (clickedTab.classList.contains("active")) return

      document.querySelectorAll(".tqas-tab-nav .tqa-tab").forEach(t => t.classList.remove("active"))
      clickedTab.classList.add("active")

      document.querySelectorAll(".tqas-tab-panel").forEach(panel => panel.classList.remove("active"))

      const tabKey = clickedTab.getAttribute("data-tab")
      const activePanel = document.querySelector(`.tqas-tab-panel[data-tab-panel="${tabKey}"]`)
      if (activePanel) activePanel.classList.add("active")

      const countElement = document.querySelector(".tqa-count")
      if (countElement && activePanel) {
        const itemCount = activePanel.querySelectorAll(".tqa-card").length
        let itemType: string
        if (tabKey === "all") {
          itemType = "triggers, queries, and actions"
        } else if (itemCount === 1) {
          itemType = singularizeStepType(tabKey)
        } else {
          itemType = tabKey ?? ""
        }
        countElement.textContent = `${itemCount} ${itemType}`
      }

      updateLoadMoreButtonVisibility()
    })
  })

  function updateLoadMoreButtonVisibility() {
    const activePanel = document.querySelector(".tqas-tab-panel.active")
    const loadMoreContainer = document.querySelector(".tqas-load-more-container")

    if (!activePanel || !loadMoreContainer) return

    const remainingItems = activePanel.querySelector(".tqas-remaining-items")
    const shouldShow = remainingItems && remainingItems.children.length > 0 && remainingItems.style.display === "none"

    loadMoreContainer.style.display = shouldShow ? "block" : "none"
  }

  const loadMoreButton = document.querySelector(".tqas-load-more-btn")
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", event => {
      event.preventDefault()

      const activePanel = document.querySelector(".tqas-tab-panel.active")
      const remainingItems = activePanel?.querySelector(".tqas-remaining-items")
      const loadMoreContainer = document.querySelector(".tqas-load-more-container")

      if (remainingItems) {
        remainingItems.style.display = "grid"
        if (loadMoreContainer) loadMoreContainer.style.display = "none"
      }
    })
  }

  updateLoadMoreButtonVisibility()
}

export default TqaListTabs
